// index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; 
import { BrowserRouter } from 'react-router-dom'; 
import App from './components/App'; // Ensure this path is correct
import ReactGA from 'react-ga';

ReactGA.initialize('G-GGX62R4PCG');
const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

